import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngxs/store";
import {UserInterface} from "../models/user.interface";
import {RequestService} from "./request.service";
import {Router} from "@angular/router";
import {LoaderService} from "./loader.service";
import {AppState} from "../states/app.state";
import {JwtHelper} from "../helpers/jwt.helper";
import {AppHelper} from "../helpers/app.helper";
import {UserAction} from "../actions/user-action";
import RefreshToken = UserAction.RefreshToken;
import {StateReset} from "ngxs-reset-plugin";
import {DOCUMENT} from "@angular/common";
import {InstrumentoState} from "../states/instrumento.state";
import {CarteraState} from "../states/cartera.state";
import {CarteraAction} from "../actions/cartera-action";
import { WalletsAction } from '../actions/wallets-action';
import FetchTipoOperacion = CarteraAction.FetchTipoOperacion;
import {InstrumentoAction} from "../actions/instrumento-action";
import FetchTiposInstrumento = InstrumentoAction.FetchTiposInstrumento;
import FetchCarteras = CarteraAction.FetchCarteras;
import FetchWallets = WalletsAction.FetchWallets;
import FetchSectores = InstrumentoAction.FetchSectores;
import FetchFuentes = CarteraAction.FetchFuentes;
import FetchColumnas = CarteraAction.FetchColumnas;
import FetchTags = CarteraAction.FetchTags;
import FetchBrokers = CarteraAction.FetchBrokers;
import FetchTipoVencimiento = CarteraAction.FetchTipoVencimiento;
import { OperationsSymbolState } from '../states/operations-symbol.state';
import { PaginationState } from '../states/pagination.state';
import { WalletState } from '../states/wallets.state';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

  private _profile: UserInterface;

  get profile() {

    return this._profile;
  }

  set profile(p: UserInterface) {


    if (p?.token && p.token !== this.profile?.token) {

      const time = Math.max(JwtHelper.GetExpirationTime(p.token) - 1000, 0);

      AppHelper.DevPrint(`Token se actualizará en ${time / 60000}min`);

      AppHelper.Wait(time).then(() => {

        this.store.dispatch(new RefreshToken()).subscribe(() => {

          AppHelper.DevPrint('Token Actualizado!');
        });
      });
    }

    this.requestService.token = p?.token;
    this._profile = p;
  }

  constructor(@Inject(DOCUMENT) private document: Document, private store: Store, private requestService: RequestService,
              private router: Router, private loaderService: LoaderService) {

    this.store.select(AppState.profile).subscribe((p: UserInterface) => {

      this.profile = p;

      if (p.token) {

        this.downloadAssets();
      }
    });

    this.requestService.onEndSession.subscribe(() => {

      AppHelper.ShowAlertError('', 'Su sesión ha Finalizado!').then(() => this.logout());
    });
  }

  downloadAssets() {

    this.store.dispatch(new FetchTipoOperacion());
    this.store.dispatch(new FetchFuentes());
    this.store.dispatch(new FetchBrokers());
    this.store.dispatch(new FetchTipoVencimiento());
    this.store.dispatch(new FetchColumnas('cartera'));
    this.store.dispatch(new FetchColumnas('operacion'));
    this.store.dispatch(new FetchTiposInstrumento());
    this.store.dispatch(new FetchSectores());
    this.store.dispatch(new FetchWallets());
   // this.store.dispatch(new FetchCarteras());
    this.store.dispatch(new FetchTags());
  }

  isAuthenticated() {

    if (!this.profile) {

      return;
    }

    return !(!this.profile.email) && !(!this.profile.token) && !(!this.profile.refreshToken);
  }

  async logout() {

    this.loaderService.show();
    this.store.dispatch(new StateReset(AppState, InstrumentoState, CarteraState, OperationsSymbolState, PaginationState, WalletState));
    this.store.reset;
    this.document.location.href = '/';
    await AppHelper.Wait(800);
    this.loaderService.hide();
  }

}
